import styles from './Modal.module.scss';

export const Modal = ({ isOpen, title, children, onClose, onConfirm, confirmLabel }) => {
  if (!isOpen) return null;

  const handleBackdropClick = event => {
    if (event.target === event.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div className={styles.content}>
        {title && <h2 className={styles.header}>{title}</h2>}

        {children}

        <div className={styles.actions}>
          <button type="button" className={`${styles.button} ${styles.buttonSecondary}`} onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.buttonPrimary}`}
            onClick={onConfirm}
          >
            {confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};

